module.exports = __webpack_public_path__ + "img/logo.96d6af32.png";